// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.before-after-comparison {
  box-shadow: 0px 8px 24px 0px rgba(109, 114, 121, 0.08);
}

@media (max-width: 768px) {
  .before-after-comparison {
    width: calc(100% + var(--page-side-padding-768) * 2);
  }
}

/* desktop */
@media (min-width: 1280px) {
  .before-after-comparison {
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
  }
}

.before-after-comparison .image-container {
  background: var(--select-plan-header-background);
  padding: 0 24px;
}

@media (max-width: 768px) {
  .before-after-comparison .image-container {
    padding-left: var(--page-side-padding-768);
    padding-right: var(--page-side-padding-768);
  }
}

.before-after-comparison .image-container img {
  max-width: 100%;
}

.before-after-comparison .parameters {
  display: flex;

  background-color: white;
  padding: 24px;
}

@media (max-width: 768px) {
  .before-after-comparison .parameters {
    padding-left: var(--page-side-padding-768);
    padding-right: var(--page-side-padding-768);
  }
}

/* desktop */
@media (min-width: 1280px) {
  .before-after-comparison .parameters {
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
  }
}

.before-after-comparison .before {
  padding-right: 19px;

  border-right: 1px solid var(--space-gray);
}

.before-after-comparison .after {
  padding-left: 20px;
}

.before-after-comparison .title {
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
}

.before-after-comparison .value {
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}

.before-after-comparison .body-fat {
  padding-bottom: 32px;
}

.before-after-comparison .workout-level {
  padding-top: 10px;
  border-top: 1px solid var(--space-gray);
}

.before-after-comparison .chart {
  display: flex;
  margin-top: 16px;
}

.before-after-comparison .chart .bar {
  border-radius: 2px;
  background-color: var(--select-plan-header-background);
  height: 8px;
  width: 44px;
}

.before-after-comparison .chart .bar.active {
  background-color: var(--main-highlight-color);
}

.before-after-comparison .chart .bar + .bar {
  margin-left: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.before-after-comparison.css"],"names":[],"mappings":"AAAA;EACE,sDAAsD;AACxD;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA,YAAY;AACZ;EACE;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;AACF;;AAEA;EACE,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE;IACE,0CAA0C;IAC1C,2CAA2C;EAC7C;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;;EAEb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE;IACE,0CAA0C;IAC1C,2CAA2C;EAC7C;AACF;;AAEA,YAAY;AACZ;EACE;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;AACF;;AAEA;EACE,mBAAmB;;EAEnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,WAAW;EACX,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".before-after-comparison {\n  box-shadow: 0px 8px 24px 0px rgba(109, 114, 121, 0.08);\n}\n\n@media (max-width: 768px) {\n  .before-after-comparison {\n    width: calc(100% + var(--page-side-padding-768) * 2);\n  }\n}\n\n/* desktop */\n@media (min-width: 1280px) {\n  .before-after-comparison {\n    border-bottom-left-radius: 24px;\n    border-bottom-right-radius: 24px;\n  }\n}\n\n.before-after-comparison .image-container {\n  background: var(--select-plan-header-background);\n  padding: 0 24px;\n}\n\n@media (max-width: 768px) {\n  .before-after-comparison .image-container {\n    padding-left: var(--page-side-padding-768);\n    padding-right: var(--page-side-padding-768);\n  }\n}\n\n.before-after-comparison .image-container img {\n  max-width: 100%;\n}\n\n.before-after-comparison .parameters {\n  display: flex;\n\n  background-color: white;\n  padding: 24px;\n}\n\n@media (max-width: 768px) {\n  .before-after-comparison .parameters {\n    padding-left: var(--page-side-padding-768);\n    padding-right: var(--page-side-padding-768);\n  }\n}\n\n/* desktop */\n@media (min-width: 1280px) {\n  .before-after-comparison .parameters {\n    border-bottom-left-radius: 24px;\n    border-bottom-right-radius: 24px;\n  }\n}\n\n.before-after-comparison .before {\n  padding-right: 19px;\n\n  border-right: 1px solid var(--space-gray);\n}\n\n.before-after-comparison .after {\n  padding-left: 20px;\n}\n\n.before-after-comparison .title {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.before-after-comparison .value {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.before-after-comparison .body-fat {\n  padding-bottom: 32px;\n}\n\n.before-after-comparison .workout-level {\n  padding-top: 10px;\n  border-top: 1px solid var(--space-gray);\n}\n\n.before-after-comparison .chart {\n  display: flex;\n  margin-top: 16px;\n}\n\n.before-after-comparison .chart .bar {\n  border-radius: 2px;\n  background-color: var(--select-plan-header-background);\n  height: 8px;\n  width: 44px;\n}\n\n.before-after-comparison .chart .bar.active {\n  background-color: var(--main-highlight-color);\n}\n\n.before-after-comparison .chart .bar + .bar {\n  margin-left: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
